import { useEffect } from 'react';

export default function useAsyncEffect(fn: () => Promise<void>, dependencies: any[]) {
  useEffect(() => {
    fn();
  }, dependencies);
}
